import { render, staticRenderFns } from "./ReportedQuestionsView.vue?vue&type=template&id=6c30bd7d&"
import script from "./ReportedQuestionsView.vue?vue&type=script&lang=js&"
export * from "./ReportedQuestionsView.vue?vue&type=script&lang=js&"
import style0 from "./ReportedQuestionsView.vue?vue&type=style&index=0&id=6c30bd7d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports